<template>
    <div :class="'swiper-slide ' + this.swiperClass">
        <div class="tariffitem" :id="'tarif' + tarif.uid">
            <div class="img-txt-teaser-tariffoffer">
                <div :class="'gradient ' + this.gradientClass +' highlight'" v-if="settings.anzeigehighlight && settings.highlighttarif.includes(tarif.uid) && tarif.highlight_text" v-html="tarif.highlight_text"></div>
                <div class="img">
                    <img :src="absolutizeUrl(tarif.bildurl)" :alt="'Bild Tarif ' + tarif.name_extern">
                </div>
                <div class="txt txt-01">
                    <div class="head" v-html="tarif.name_extern"></div>
                    <span v-if="tarif.commodity === 1" class="addition text-center">Ökostrom</span>
                    <div class="sub">
                        {{tarif.unterzeile}}
                    </div>
                    <div class="sum">
                        <span>{{ preis_formatted }}</span>
                        <span class="append">Ø pro Monat</span>
                        <span class="info-button" data-trigger="hover" data-container="body" data-toggle="popover" data-placement="top" data-html="true" :data-content="tarif.preisinfo" v-if="tarif.preisinfo"></span><!-- <sup>1</sup> -->
                    </div>
                    <div class="savings text-center" v-if="gvsSwboPreis > 0 && gvsSwboPreis == 'test'">
                        <b>
<!--                            gvs: {{gvsPreis}} swbo: {{ preis_formatted_year }}<br>-->
                            {{gvsSwboPreis}} € Ersparnis im Jahr
                            <sup>1</sup>
                        </b>
                    </div>
                    <div style="text-align: center" class="custom-control custom-checkbox" v-if="this.tarif.jvl && this.tarif.jvl_hoehe > 0" :data-hoehe="this.tarif.jvl_hoehe" @click="handleJvlClick">
                        <input class="custom-control-input jvl" type="checkbox" :id="'jvl' + tarif.uid" ref="checkbox">
                        <label class="custom-control-label" :for="'jvl' + tarif.uid">
                            bei Jahresvorauszahlung {{ this.tarif.jvl_hoehe }} % Rabatt
                        </label>
                    </div>
                    <div class="pricehistory" v-if="tarif.tarif_typ === 2 && settings.layoutergebnisseite === 'horizontal'">
                        <a href="#" class="pricehistory-button" @click.prevent="$refs.pricehistoryModal.open()">Strompreisverlauf anzeigen</a>
                        <Modal ref="pricehistoryModal" size="xl" white-header>
                            <PriceHistory
                                :plz="plz"
                                :color="tarif.farbigkeit === 'gruen' ? 'green' : ''"
                                :tarif-id="tarif.flex_id"
                                :regular-price="typeof settings.flexRegularPrice === 'string' ? parseFloat(settings.flexRegularPrice.replace(',', '.')) : settings.flexRegularPrice"
                                :hide-regular="!!settings.flexHideRegular"
                                :hide-average="!!settings.flexHideAverage"
                                :hide-switch-day="!!settings.flexHideSwitchDay"
                                :hide-switch-savings="!!settings.flexHideSwitchSavings"
                                :text-before="settings.flexTextBefore"
                                :text-after="settings.flexTextAfter"
                            />
                        </Modal>
                    </div>
                </div>
                <div class="pricedetails" :class="{'extended': toggleDetails}" @click="(event) => this.$emit('togglePriceDetails', event)">

                    <div class="button-details">
<!--                        <span>Preisdetails</span>-->
                        <button class="collapsed"
                                type="button"
                                data-toggle="collapse"
                                :data-target="'.product-price-details'"
                                aria-expanded="false"
                                :aria-controls="'product-price-details'"
                                @click="scrollToDetails"
                                :data-scrollto="'#tarif' + tarif.uid" tabindex="0"
                                aria-label="Preisdetails">Preisdetails</button>
                    </div>


                    <div class="product-price-details" ref="product-price-details">
                        <table>
                            <tbody>
                            <tr v-if="tarif.preisinfo_arbeitspreis_sichtbar">
                                <td><span>{{ tarif.preisinfo_arbeitspreis_text || 'Preis pro kWh'}}</span></td><td class="text-nowrap">{{ tarif.preiseMitRabatt.workingPriceFormatted }} Cent</td>
                            </tr>

                            <tr v-if="tarif.preisinfo_grundpreis_monat_sichtbar">
                                <td><span>{{ tarif.preisinfo_grundpreis_monat_text || 'Grundpreis pro Monat' }}</span></td><td class="text-nowrap">{{ tarif.preiseMitRabatt.basePricePerMonthFormatted }} €</td>
                            </tr>

                            <tr v-if="tarif.preisinfo_abschlag_inbo_sichtbar && tarif.preiseMitRabatt.type === 1">
                            <!-- Inbo -->
                                <td><span><strong>{{ tarif.preisinfo_abschlag_inbo_text || 'Ihr Monatsabschlag (11 Abschläge)' }}</strong></span></td><td class="text-nowrap"><strong>{{ abschlag_formatted }}</strong></td>
                            </tr>
                            <tr v-else-if="tarif.preisinfo_abschlag_exbo_sichtbar">
                                <!-- Exbo -->
                                <td><span><strong>{{ tarif.preisinfo_abschlag_exbo_text || 'Ihr Monatsabschlag (12 Abschläge)' }}</strong></span></td><td class="text-nowrap"><strong>{{ abschlag_formatted }}</strong></td>
                            </tr>
                            <tr v-if="tarif.preisinfo_gesamtpreis_jahr_sichtbar">
                                <td><span><strong>{{ tarif.preisinfo_gesamtpreis_jahr_text || 'Gesamtpreis im ersten Jahr' }}</strong></span></td><td class="text-nowrap"><strong>{{ preis_formatted_year }}</strong></td>
                            </tr>
                            <tr v-if="tarif.preisinfo_gesamtpreis_monat_sichtbar">
                                <td><span><strong>{{ tarif.preisinfo_gesamtpreis_monat_text || 'Ø Preis pro Monat (bei 12 Monaten)' }}</strong></span></td><td class="text-nowrap"><strong>{{ preis_formatted }}</strong></td>
                            </tr>
                            </tbody></table>
                        <div v-if="tarif.preisdetails" v-html="tarif.preisdetails"></div>

                    </div>

<!--                    <div>Preise gültig ab {{ tarif.preis_gueltig_von }}</div>-->
                </div>
                <div class="features" :class="featuresClass">
                    <FeatureBadge v-if="tarif.featurebadge" :text="tarif.featurebadge" />
                    <ul class="featurelist">
                        <li v-for="(datahl, indexhl) in tarif.tarif_produkthighlight"
                            :key="indexhl" v-html="datahl.highlight.erklaerung"></li>
                    </ul>
                </div>
                <div class="txt txt-02">

                    <div class="options">
                        <div>
<!--                            Nur für Strom-->
                            <div class="options-intro" v-if="tarif.commodity === 1">
                                <p v-if="tarif.unterzeile_produkthighlight" class="heart-icon">{{ tarif.unterzeile_produkthighlight }}</p>
                                <p v-if="tarif.zusatzzeile_produkthighlight" class="font-green" v-html="tarif.zusatzzeile_produkthighlight"></p>
                                <p>
                                    <a href="#" class="m-0 link-modal" @click.prevent="$refs.splitModal.open()"
                                       v-if="tarif.ueberschrift_modal_links && tarif.text_modal_links && tarif.text_modal_rechts">
                                        Mehr Infos
                                    </a>
                                    <SplitModal ref="splitModal" size="xl" white-header
                                                :headline-left="tarif.ueberschrift_modal_links"
                                                :text-left="tarif.text_modal_links"
                                                :text-right="tarif.text_modal_rechts"
                                    />
                                </p>
                            </div>
                        </div>
                        <preisoptions-gruppe
                            v-for="gruppe in tarif.tarif_preisoptionen"
                            :gruppe="gruppe"
                            :key="gruppe.uid"
                            :value="preisoptionen"
                            @input="$emit('input:preisOptionen', $event)"
                            :commodity="tarif.commodity"
                        />
                    </div>
                    <div class="buttons">
                        <a class="btn btn-primary d-block" @click="checkout" @keyup.enter="checkout" tabindex="0" aria-label="Jetzt bestellen">Jetzt bestellen</a>
                        <p></p>
                    </div>
                </div>

                <div class="txt txt-03">
                    <!-- START details -->
                    <div ref="details" class="details collapse" :id="'collapseDetails01' + tarif.uid">
                        <div class="inner" v-html="tarif.kurzbeschreibung"></div>
                        <div class="inner" v-if="tarif.anhaenge_anzeigen">
                            <ul class="linklist" v-if="tarif.agb || tarif.besondere_bedingungen || tarif.preisblatturl">
                                <li v-if="tarif.agburl"><a :href="absolutizeUrl(tarif.agburl)">AGB</a></li>
                                <li v-if="tarif.besondere_bedingungenurl"><a :href="absolutizeUrl(tarif.besondere_bedingungenurl)">Besondere Bedingungen</a></li>
                                <li v-if="tarif.preisblatt && tarif.preisblatturl"><a :href="absolutizeUrl(tarif.preisblatturl)">Preisblatt</a></li>
                            </ul>
                        </div>
                    </div>
                    <!-- END details -->
                    <div class="button-details">
                        <button class="collapsed"
                                type="button"
                                data-toggle="collapse"
                                :data-target="'.details'"
                                aria-expanded="false"
                                :aria-controls="'details'"
                                @click="scrollToDetails"
                                :data-scrollto="'#tarif' + tarif.uid"
                                aria-label="Tarifdetails">Tarifdetails</button>
                    </div>
                </div>


                <div :class="'gradient ' + this.gradientClass"></div>
            </div>
        </div>
    </div>
</template>
<script>
import PreisoptionsGruppe from "@/components/PreisoptionsGruppe";
import {berechneJahrespreis, berechneMonatsabschlag, berechneGvsPreis, berechneMonatspreis, diffGvsSwboPreis} from "@/util/tarif";
import FeatureBadge from "@/components/FeatureBadge.vue";
import Modal from "@/components/Modal.vue";
import SplitModal from "@/components/SplitModal.vue";
import PriceHistory from "@/components/PriceHistory.vue";
import urlMixin from "@/mixins/urlMixin";
// import MatchHeight from "@tannerhodges/match-height";

export default {
    name: 'TarifListItem',
    mixins: [urlMixin],
    components: {SplitModal, PriceHistory, Modal, FeatureBadge, PreisoptionsGruppe },
    data() {
        return {
            jvl: 0,
        }
    },
    props: {
        settings: {
            type: Object,
            default: () => {},
        },
        tarif: {
            type: Object,
            default: () => {},
        },
        // Objekt mit allen verfügbaren Preisoptionen der Tarifliste (hat auch Einträge für Preisoptionen welche nicht für den Tarif verfügbar sind)
        preisoptionen: Object,
        toggleDetails: {
            type: Boolean,
            default: false
        },
        grundversorger: {
            type: Object,
            default: () => {}
        },
        plz: {
            type: String,
            default: '',
        }
    },
    computed: {
        // Objekt mit Preisoptionen welche nur in dem Vertrag möglich sind.
        tarif_preisoptionen() {
            const preisoptionen = {}
            this.tarif.tarif_preisoptionen.forEach(({uid, standard_position}) => {
                if (typeof this.preisoptionen[uid] !== 'undefined')
                    preisoptionen[uid] = this.preisoptionen[uid];
                else if(standard_position)
                    preisoptionen[uid] = standard_position.betrag;
            });
            return preisoptionen;
        },
        preis_formatted() {
            return berechneMonatspreis(this.tarif, this.tarif.preis, this.tarif_preisoptionen, this.jvl).format();
        },
        preis_formatted_year() {
            return berechneJahrespreis(this.tarif, this.tarif.preis, this.tarif_preisoptionen, this.jvl).format();
        },
        abschlag_formatted() {
            return berechneMonatsabschlag(this.tarif, this.tarif.preis, this.tarif_preisoptionen, this.tarif.preiseMitRabatt.type, this.jvl).format();
        },
        swiperClass(){
            if(this.tarif.farbigkeit == 'gruen') return 'tarif-green';
            return '';
        },
        gradientClass(){
            if(this.tarif.farbigkeit == 'gruen') return 'gradient-green';
            return 'gradient-orange';
        },
        gvsPreis(){
            return berechneGvsPreis(this.grundversorger.gesamtkosten).format();
        },
        gvsSwboPreis(){
            return diffGvsSwboPreis(this.grundversorger.gesamtkosten.toString().replace('.', ','), this.preis_formatted_year);
        },
        featuresClass() {
            switch (this.tarif.hintergrund_featurebadge) {
                case 1: return 'special';
                default: return '';
            }
        },
        besondereBedingungenUrlAbsolute() {
            if (!this.tarif.besondere_bedingungenurl) return null;

            // Einen führenden Slash entfernen, wenn zwei vorhanden sind
            let cleanedUrl = this.tarif.besondere_bedingungenurl.replace(/^\/{2,}/, '/');

            if (/^https?:\/\//.test(cleanedUrl)) {
                return cleanedUrl;
            }

            return window.location.origin + cleanedUrl;
        },
        agbUrlAbsolute() {
            if (!this.tarif.agburl) return null;

            // Einen führenden Slash entfernen, wenn zwei vorhanden sind
            let cleanedUrl = this.tarif.agburl.replace(/^\/{2,}/, '/');

            if (/^https?:\/\//.test(cleanedUrl)) {
                return cleanedUrl;
            }

            return window.location.origin + cleanedUrl;
        },
        preisblattUrlAbsolute() {
            if (!this.tarif.preisblatturl) return null;

            // Einen führenden Slash entfernen, wenn zwei vorhanden sind
            let cleanedUrl = this.tarif.preisblatturl.replace(/^\/{2,}/, '/');

            if (/^https?:\/\//.test(cleanedUrl)) {
                return cleanedUrl;
            }

            return window.location.origin + cleanedUrl;
        }
    },
    methods: {
        checkout() {
            // nur die preisoptione welche im tarif möglich sind übergeben
            this.$emit('checkout', this.tarif, this.tarif_preisoptionen, this.jvl)
        },
        scrollToDetails(e) {
            const el = e.target.ariaExpanded === 'true' ? this.$el : this.$refs.details;
            if (el) {
                setTimeout(() => {
                    if(this.settings.debugmodus) console.log('scrolling');
                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                    this.$emit('applyMatchHeightToTariffItems');
                }, 350)
            }
        },
        handleJvlClick(e) {
            if (this.$refs.checkbox.checked) {
                this.jvl = e.currentTarget.getAttribute('data-hoehe');
            } else {
                this.jvl = 0;
            }
        }
    },
}
</script>
